export const FETCH_LOADDATA_INIT = "FETCH_LOADDATA_INIT";
export const FETCH_LOADDATA_SUCCESS = FETCH_LOADDATA_INIT + "_SUCCESS";
export const FETCH_LOADDATA_FAIL = FETCH_LOADDATA_INIT + "_FAIL";

export const FETCH_LOADDATABYID_INIT = "FETCH_LOADDATABYID_INIT";
export const FETCH_LOADDATABYID_SUCCESS = FETCH_LOADDATABYID_INIT + "_SUCCESS";
export const FETCH_LOADDATABYID_FAIL = FETCH_LOADDATABYID_INIT + "_FAIL";

export const FETCH_CARGOTYPE_INIT = "FETCH_CARGOTYPE_INIT";
export const FETCH_CARGOTYPE_SUCCESS = FETCH_CARGOTYPE_INIT + "_SUCCESS";
export const FETCH_CARGOTYPE_FAIL = FETCH_CARGOTYPE_INIT + "_FAIL";

export const ADD_LOAD_INIT = "ADD_LOAD_INIT";
export const ADD_LOAD_SUCCESS = ADD_LOAD_INIT + "_SUCCESS";
export const ADD_LOAD_FAIL = ADD_LOAD_INIT + "_FAIL";

export const EDIT_LOAD_INIT = "EDIT_LOAD_INIT";
export const EDIT_LOAD_SUCCESS = EDIT_LOAD_INIT + "_SUCCESS";
export const EDIT_LOAD_FAIL = EDIT_LOAD_INIT + "_FAIL";

export const FETCH_RUNNERS_INIT = "FETCH_RUNNERS_INIT";
export const FETCH_RUNNERS_SUCCESS = FETCH_RUNNERS_INIT + "_SUCCESS";
export const FETCH_RUNNERS_FAIL = FETCH_RUNNERS_INIT + "_FAIL";

export const FETCH_CARGOSIZE_INIT = "FETCH_CARGOSIZE_INIT";
export const FETCH_CARGOSIZE_SUCCESS = FETCH_CARGOSIZE_INIT + "_SUCCESS";
export const FETCH_CARGOSIZE_FAIL = FETCH_CARGOSIZE_INIT + "_FAIL";

export const FETCH_LOADMATRIX_INIT = "FETCH_LOADMATRIX_INIT";
export const FETCH_LOADMATRIX_SUCCESS = FETCH_LOADMATRIX_INIT + "_SUCCESS";
export const FETCH_LOADMATRIX_FAIL = FETCH_LOADMATRIX_INIT + "_FAIL";

export const GETVEHICLE_INIT = "GETVEHICLE_INIT";
export const GETVEHICLE_SUCCESS = GETVEHICLE_INIT + "_SUCCESS";
export const GETVEHICLE_FAIL = GETVEHICLE_INIT + "_FAIL";

export const GET_DISTANCE_INIT = "GET_DISTANCE_INIT";
export const GET_DISTANCE_SUCCESS = GET_DISTANCE_INIT + "_SUCCESS";
export const GET_DISTANCE_FAIL = GET_DISTANCE_INIT + "_FAIL";

export const GET_RATECARD_INIT = "GET_RATECARD_INIT";
export const GET_RATECARD_SUCCESS = GET_RATECARD_INIT + "_SUCCESS";
export const GET_RATECARD_FAIL = GET_RATECARD_INIT + "_FAIL";

export const GET_PAYMODE_INIT = "GET_PAYMODE_INIT";
export const GET_PAYMODE_SUCCESS = GET_PAYMODE_INIT + "_SUCCESS";
export const GET_PAYMODE_FAIL = GET_PAYMODE_INIT + "_FAIL";

export const GET_TOTALVEHICLE_INIT = "GET_TOTALVEHICLE_INIT";
export const GET_TOTALVEHICLE_SUCCESS = GET_TOTALVEHICLE_INIT + "_SUCCESS";
export const GET_TOTALVEHICLE_FAIL = GET_TOTALVEHICLE_INIT + "_FAIL";

export const GET_NEAREST_RUNNERS_INIT = "GET_NEAREST_RUNNERS_INIT";
export const GET_NEAREST_RUNNERS_SUCCESS =
  GET_NEAREST_RUNNERS_INIT + "_SUCCESS";
export const GET_NEAREST_RUNNERS_FAIL = GET_NEAREST_RUNNERS_INIT + "_FAIL";

export const GET_SUBSCRIPTION_STATUS = "GET_SUBSCRIPTION_STATUS";
export const GET_SUBSCRIPTION_SUCCESS = GET_SUBSCRIPTION_STATUS + "_SUCCESS";
export const GET_SUBSCRIPTION_FAIL = GET_SUBSCRIPTION_STATUS + "_FAIL";

export const GET_BID_DATA_BY_ID_ACTION = "GET_BID_DATA_BY_ID_ACTION";
export const GET_BID_DATA_BY_ID_ACTION_SUCCESS =
  GET_BID_DATA_BY_ID_ACTION + "_SUCCESS";
export const GET_BID_DATA_BY_ID_ACTION_FAIL =
  GET_BID_DATA_BY_ID_ACTION + "_FAIL";

export const GET_BID_UPDATE_DATA_BY_ID_ACTION =
  "GET_BID_UPDATE_DATA_BY_ID_ACTION";
export const GET_BID_UPDATE_DATA_BY_ID_ACTION_SUCCESS =
  GET_BID_UPDATE_DATA_BY_ID_ACTION + "_SUCCESS";
export const GET_BID_UPDATE_DATA_BY_ID_ACTION_FAIL =
  GET_BID_UPDATE_DATA_BY_ID_ACTION + "_FAIL";

export const GET_SPECIFICRUNNER_INIT = "GET_SPECIFICRUNNER_INIT";
export const GET_SPECIFICRUNNER_SUCCESS = GET_SPECIFICRUNNER_INIT + "_SUCCESS";
export const GET_SPECIFICRUNNER_FAIL = GET_SPECIFICRUNNER_INIT + "_FAIL";

export const GET_SPECIFIC_CARGO_INIT = "GET_SPECIFIC_CARGO_INIT";
export const GET_SPECIFIC_CARGO_SUCCESS = GET_SPECIFIC_CARGO_INIT + "_SUCCESS";
export const GET_SPECIFIC_CARGO_FAIL = GET_SPECIFIC_CARGO_INIT + "_FAIL";

export const CANCEL_LOAD_INIT = "CANCEL_LOAD_INIT";
export const CANCEL_LOAD_SUCCESS = CANCEL_LOAD_INIT + "_SUCCESS";
export const CANCEL_LOAD_FAIL = CANCEL_LOAD_INIT + "_FAIL";

export const FETCH_CURRENCY_INIT="FETCH_CURRENCY_INIT";
export const FETCH_CURRENCY_SUCCESS = FETCH_CURRENCY_INIT+"_SUCCESS";
export const FETCH_CURRENCY_FAIL = FETCH_CURRENCY_INIT+"_FAIL";

export const FETCH_SUB_FORRUNNER_INIT = "FETCH_SUB_FORRUNNER_INIT";
export const FETCH_SUB_FORRUNNER_SUCCESS = FETCH_SUB_FORRUNNER_INIT+"_SUCCESS";
export const FETCH_SUB_FORRUNNER_FAIL = FETCH_SUB_FORRUNNER_INIT+"_FAIL";

export const FETCH_PAYCANCELLATION_INIT = "FETCH_PAYCANCELLATION_INIT";
export const FETCH_PAYCANCELLATION_SUCCESS = FETCH_PAYCANCELLATION_INIT+"_SUCCESS";
export const FETCH_PAYCANCELLATION_FAIL = FETCH_PAYCANCELLATION_INIT+"_FAIL";

export const FETCH_RUNNERVEHICLES_INIT = "FETCH_RUNNERVEHICLES_INIT";
export const FETCH_RUNNERVEHICLES_SUCCESS = FETCH_RUNNERVEHICLES_INIT+"_SUCCESS";
export const FETCH_RUNNERVEHICLES_FAIL = FETCH_RUNNERVEHICLES_INIT+"FAIL";

export function fetchLoaddata(value) {
  return {
    type: FETCH_LOADDATA_INIT,
    payload: value,
  };
}

export function fetchSpecificLoaddata(value) {
  return {
    type: FETCH_LOADDATABYID_INIT,
    value: value,
  };
}

export function fetchCargotype() {
  return {
    type: FETCH_CARGOTYPE_INIT,
  };
}

export function addLoad(value) {
  return {
    type: ADD_LOAD_INIT,
    value: value,
  };
}

export function editLoad(value) {
  return {
    type: EDIT_LOAD_INIT,
    value: value,
  };
}

export function fetchRunners() {
  return {
    type: FETCH_RUNNERS_INIT,
  };
}

export function fetchCargoSize() {
  return {
    type: FETCH_CARGOSIZE_INIT,
  };
}

export function fetchLoadmatrix() {
  return {
    type: FETCH_LOADMATRIX_INIT,
  };
}

export function getVehicleType(value) {
  return {
    type: GETVEHICLE_INIT,
    payload: value,
  };
}

export function getDistance(value) {
  return {
    type: GET_DISTANCE_INIT,
    payload: value,
  };
}

export function getRateCard(value) {
  return {
    type: GET_RATECARD_INIT,
    // payload: value,
  };
}

export function getPaymentMode() {
  return {
    type: GET_PAYMODE_INIT,
  };
}

export function getVehicles() {
  return {
    type: GET_TOTALVEHICLE_INIT,
  };
}

export function getNearestRunners(value) {
  return {
    type: GET_NEAREST_RUNNERS_INIT,
    value: value,
  };
}

export function fetchSubscriptionStatus(value) {
  return {
    type: GET_SUBSCRIPTION_STATUS,
    value: value,
  };
}

export function fetchBidByIdAction(value) {
  return {
    type: GET_BID_DATA_BY_ID_ACTION,
    value: value,
  };
}

export function updateBidByIdAction(value) {
  return {
    type: GET_BID_UPDATE_DATA_BY_ID_ACTION,
    value: value,
  };
}

export function fetchSpecificRunner(value) {
  return {
    type: GET_SPECIFICRUNNER_INIT,
    value: value,
  };
}

export function fetchSpecificCargo(value) {
  return {
    type: GET_SPECIFIC_CARGO_INIT,
    value: value,
  };
}

export function cancelLoad(value) {
  return {
    type: CANCEL_LOAD_INIT,
    value: value,
  };
}

export function fetchcurrency(){
  return{
    type:FETCH_CURRENCY_INIT
  }
}

export function fetchSubscriptionagainstRunner(value){
  return {
    type:FETCH_SUB_FORRUNNER_INIT,
    value:value
  }
}

export function fetchPaymentCancellation(value){
  return {
    type:FETCH_PAYCANCELLATION_INIT,
    value:value
  }
}

export function fetchTheRunnerVehicles(value){
  return {
    type:FETCH_RUNNERVEHICLES_INIT,
    value:value
  }
}